import axios from 'axios'
export default {
	_get (uri) {
		return axios.get('invitaciones/php/api/' + uri)
	},
	_post (uri, data) {
		return axios.post('invitaciones/php/api/' + uri, data)
	},
	getEventos (soloAbiertos) {
		if (soloAbiertos) {
			return this._get('listado-eventos.php?abiertos=true')
		} else {
			return this._get('listado-eventos.php')
		}
	},
	getGrupos (idEvento) {
		return this._get('listado-grupos.php?EventoID=' + idEvento)
	},
	buscarInvitados (datos) {
		return this._post('buscar-invitados.php', datos)
	},
	getInvitado (idInvitado) {
		return this._get('get-invitado.php?InvitadoID=' + idInvitado)
	},
	setInvitado (datos) {
		return this._post('set-invitado.php', datos)
	},
	getRecinto (EventoID) {
		return this._get('verRecinto.php?EventoID=' + EventoID)
	},
	download (datos, orden) {
		const filtro = {...datos, ...orden}
		axios({
			url: 'invitaciones/php/api/getPDF.php',
			method: 'POST',
			data: filtro,
			responseType: 'blob',
			headers: {
				'Content-type': 'application/json',
				'Accept': 'application/x-binary'
			}
		})
			.then(res => {
				const a = document.createElement('a')
				const file = new Blob([res.data], {type: 'application/pdf'})
				console.log(file)
				const url = URL.createObjectURL(file)
				a.name = 'informe.pdf'
				a.href = url
				a.download = 'informe.pdf'
				document.body.appendChild(a)
				a.click()
				window.setTimeout(() => {
					document.body.removeChild(a)
				}, 3000)
			})
			.catch(e => {
				console.error(e)
			})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/invitaciones/vue/api.js